export const FEATURES = {
  TASKS: true,
  MESSENGER: true,
  TEAMS: true,
  FINANCE: false,
  AI_ASSISTANT: false,
  LIDAR: false,
  WORKER_ROLE: false,
} as const;
